import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

const LastBought = ({ lastBoughtDate }) => (
  <span className="fop-last-bought">
    Bought <time dateTime={new Date(lastBoughtDate).toISOString()}>{format(lastBoughtDate, 'DD/MM/YY')}</time>
  </span>
);

LastBought.propTypes = {
  lastBoughtDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]).isRequired,
};

export default LastBought;
